import React, { memo } from "react"
import CustomButton from "@Common/CustomButton"
import { useTranslation } from "react-i18next"
import { SectionHeaderWrapper } from "./styles"

interface MessagingSectionHeaderProps {
	onCreateClick: () => void
}

const MessagingSectionHeader = memo(function MessagingSectionHeader({ onCreateClick }: MessagingSectionHeaderProps) {
	const { t } = useTranslation()
	return (
		<SectionHeaderWrapper>
			<div>
				<p>{t('MESSAGING.TITLE')}</p>
				<p>{t('MESSAGING.SUBTITLE')}</p>
			</div>
			<div>
				<CustomButton
					label={t('MESSAGING.CREATE')}
					withBG
					customPadding='8px 90px'
					onClick={onCreateClick}
				/>
			</div>
		</SectionHeaderWrapper>
	)
})

export default MessagingSectionHeader
